import { css } from '@emotion/react';

export const styles = {
  box: css`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #05070A;
  `,
  card: css`
    width: 90%;
    max-width: 400px;
    background-color: #0C1018;
    color: #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    border: 1px solid #616161;
    padding: 32px;
  `,
  header: css`
    font-size: 2.125rem;
    font-weight: 600;
    text-align: center;
    color: #BDBDBD;
    margin-bottom: 16px;
  `,
    blueButton: css`
    width: 100%;
    padding: 12px 0;
    margin-top: 8px;
    font-weight: 600;
    text-transform: none;
    background-color:rgba(13, 33, 56, 0.69);
    color: #BDBDBD;
    border: 1px solid #112C4C;
    border-radius: 4px;
    &:hover {
      background-color:rgb(13, 33, 56);
      color: #FFFFFF;
      border-color: #0D2138;
    }
  `,
    greenButton: css`
    width: 100%;
    padding: 12px 0;
    margin-top: 8px;
    font-weight: 600;
    text-transform: none;
    background-color:rgba(13, 56, 42, 0.69);
    color: #BDBDBD;
    border: 1px solid #0D382A;
    border-radius: 4px;
    &:hover {
      background-color:rgb(13, 56, 42);
      color: #FFFFFF;
      border-color: #0D382A;
    }
  `,
};